import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tab,
    Tabs,
    TextField,
    Box,
    IconButton,
    CardMedia,
    Input,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const EditWorkout = () => {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);

    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const TabPanel = ({
        children,
        value,
        index,
    }: {
        children: React.ReactNode;
        value: number;
        index: number;
    }) => (
        <div hidden={value !== index}>
            {value === index && <Box sx={{ mt: 3 }}>{children}</Box>}
        </div>
    );

    return (
        <>
            <div className="main_title">
                <h1>Edit Workout</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-workout")}>
                        Manage Workout
                    </button>{" "}
                    - Edit Workout
                </p>
            </div>

            <Box className="custom_tabs1">
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    aria-label="Workout Tabs"
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    className="custom_tabs_links"
                >
                    <Tab label="General Details" />
                    <Tab label="Media" />
                    {/* <Tab label="Timer Mode" /> */}
                </Tabs>
            </Box>

            <div className="cards">

                {/* TAB 1: GENERAL DETAILS */}
                <TabPanel value={tabIndex} index={0}>
                    <div className="form">
                        <div className="gap_p">

                            {/* Upload Thumbnail */}
                            <div className="control_group w_33">
                                <label>Upload Thumbnail</label>

                                {image ? (
                                    <div className="upload_image v2 no_radius">
                                        <div className="upload_image_holder">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="thumb" />
                                            </figure>
                                            <IconButton
                                                aria-label="Remove"
                                                onClick={() => {
                                                    setImage("");
                                                    setFileName("");
                                                }}
                                                size="small"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                ) : (
                                    <label className="upload_image v2 no_radius" htmlFor="fileUpload">
                                        <Input
                                            id="fileUpload"
                                            sx={{ display: "none" }}
                                            type="file"
                                            inputProps={{ accept: "image/png,image/jpeg" }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = event.target.files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                }
                                            }}
                                        />
                                        <span className="upload_image_holder">
                                            <figure className="add_img">
                                                <img src="/static/images/placeholder.png" alt="placeholder" />
                                            </figure>
                                        </span>
                                    </label>
                                )}
                            </div>

                            {/* Workout Title */}
                            <div className="control_group w_33">
                                <label>Workout Title</label>
                                <TextField placeholder="Enter Workout Title" fullWidth />
                            </div>

                            {/* Duration */}
                            <div className="control_group w_33">
                                <label>Duration</label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>Select Duration</MenuItem>
                                    <MenuItem value="10">10 Min</MenuItem>
                                    <MenuItem value="30">30 Min</MenuItem>
                                    <MenuItem value="45">45 Min</MenuItem>
                                </Select>
                            </div>

                            {/* Category */}
                            <div className="control_group w_33">
                                <label>Category</label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>Select Category</MenuItem>
                                    <MenuItem value="hiit">HIIT</MenuItem>
                                    <MenuItem value="core">Core</MenuItem>
                                    <MenuItem value="strength">Strength</MenuItem>
                                </Select>
                            </div>

                            {/* Sub Category */}
                            <div className="control_group w_33">
                                <label>Sub Category</label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>Select Sub-Category</MenuItem>
                                    <MenuItem value="abs">Abs</MenuItem>
                                    <MenuItem value="legs">Legs</MenuItem>
                                    <MenuItem value="arms">Arms</MenuItem>
                                </Select>
                            </div>

                            {/* Difficulty Level */}
                            <div className="control_group w_33">
                                <label>Difficulty Level</label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>Select Difficulty</MenuItem>
                                    <MenuItem value="beginner">Beginner</MenuItem>
                                    <MenuItem value="intermediate">Intermediate</MenuItem>
                                    <MenuItem value="advanced">Advanced</MenuItem>
                                </Select>
                            </div>

                            {/* Muscle Group */}
                            <div className="control_group w_33">
                                <label>Muscle Group</label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>Select Muscle Group</MenuItem>
                                    <MenuItem value="full">Full Body</MenuItem>
                                    <MenuItem value="upper">Upper Body</MenuItem>
                                    <MenuItem value="lower">Lower Body</MenuItem>
                                    <MenuItem value="core">Core</MenuItem>
                                </Select>
                            </div>

                            {/* Equipment */}
                            <div className="control_group w_33">
                                <label>Equipment</label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>Select Equipment</MenuItem>
                                    <MenuItem value="none">None</MenuItem>
                                    <MenuItem value="dumbbells">Dumbbells</MenuItem>
                                    <MenuItem value="yoga">Yoga Mat</MenuItem>
                                </Select>
                            </div>

                            {/* Description */}
                            <div className="control_group w_100">
                                <label>Description</label>
                                <TextField
                                    placeholder="Enter Description"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                />
                            </div>

                        </div>

                        <div className="form_btn">
                            <Button
                                variant="contained"
                                color="success"
                                className="btn btn_primary"
                                onClick={() => setTabIndex(1)}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                </TabPanel>

                {/* TAB 2: MEDIA */}
                <TabPanel value={tabIndex} index={1}>
                    <div className="form">
                        <div className="gap_p">

                              {/* Upload Thumbnail */}
                            <div className="control_group w_33">
                                <label>Upload standed video</label>

                                {image ? (
                                    <div className="upload_image v2 no_radius">
                                        <div className="upload_image_holder">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="thumb" />
                                            </figure>
                                            <IconButton
                                                aria-label="Remove"
                                                onClick={() => {
                                                    setImage("");
                                                    setFileName("");
                                                }}
                                                size="small"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                ) : (
                                    <label className="upload_image v2 no_radius" htmlFor="fileUpload">
                                        <Input
                                            id="fileUpload"
                                            sx={{ display: "none" }}
                                            type="file"
                                            inputProps={{ accept: "image/png,image/jpeg" }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = event.target.files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                }
                                            }}
                                        />
                                        <span className="upload_image_holder">
                                            <figure className="add_img">
                                                <img style={{ objectFit: "contain" }}  src="/static/images/play2.jpg" alt="play2" />
                                            </figure>
                                        </span>
                                    </label>
                                )}
                            </div>

                        </div>

                        <div className="form_btn">
                            <Button
                                variant="contained"
                                color="success"
                                className="btn btn_primary"
                                onClick={() => setTabIndex(2)}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                </TabPanel>

                {/* TAB 3: TIMER MODE */}
                {/* <TabPanel value={tabIndex} index={2}>
                    <div className="form">
                        <div className="gap_p">

                            <div className="control_group w_33">
                                <label>Start Time</label>
                                <TextField type="number" placeholder="Enter Start Time" fullWidth />
                            </div>

                            <div className="control_group w_33">
                                <label>Rest Timer</label>
                                <TextField type="number" placeholder="Enter Rest Time" fullWidth />
                            </div>

                            <div className="control_group w_33">
                                <label>Next/End Timer</label>
                                <TextField type="number" placeholder="Enter Next/End Time" fullWidth />
                            </div>

                        </div>

                        <div className="form_btn">
                            <Button variant="contained" color="success" className="btn btn_primary">
                                Save Workout
                            </Button>
                        </div>
                    </div>
                </TabPanel> */}

            </div>
        </>
    );
};

export default EditWorkout;
